// source: accountsettings/accountsettings.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var promptoverridesources_promptoverridesources_pb = require('../promptoverridesources/promptoverridesources_pb.js');
goog.object.extend(proto, promptoverridesources_promptoverridesources_pb);
var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
goog.exportSymbol('proto.accountsettings.CHILD_REPORTING_MODE', null, global);
goog.exportSymbol('proto.accountsettings.EARLIEST_EVIDENCE_MODE', null, global);
goog.exportSymbol('proto.accountsettings.EarliestEvidencePolicy', null, global);
goog.exportSymbol('proto.accountsettings.GetAccountPromptOverrideSourceResponse', null, global);
goog.exportSymbol('proto.accountsettings.GetChildReportingConfigResponse', null, global);
goog.exportSymbol('proto.accountsettings.GetDateLimitResponse', null, global);
goog.exportSymbol('proto.accountsettings.GetHiddenReceptorsResponse', null, global);
goog.exportSymbol('proto.accountsettings.GetIndexPageColumnSettingsResponse', null, global);
goog.exportSymbol('proto.accountsettings.GetIndexPageFilterSettingsResponse', null, global);
goog.exportSymbol('proto.accountsettings.GetShowOldComplianceDashboardResponse', null, global);
goog.exportSymbol('proto.accountsettings.GetUsesNewAuditScanByDefaultResponse', null, global);
goog.exportSymbol('proto.accountsettings.IndexPageColumnSettingItem', null, global);
goog.exportSymbol('proto.accountsettings.IndexPageFilterSettingItem', null, global);
goog.exportSymbol('proto.accountsettings.PAUSE_DURATION_UNIT', null, global);
goog.exportSymbol('proto.accountsettings.ResetIndexPageColumnsRequest', null, global);
goog.exportSymbol('proto.accountsettings.ResetIndexPageFiltersRequest', null, global);
goog.exportSymbol('proto.accountsettings.SaveChildReportingConfigRequest', null, global);
goog.exportSymbol('proto.accountsettings.SaveChildReportingConfigResponse', null, global);
goog.exportSymbol('proto.accountsettings.SetIndexPageColumnVisibilityRequest', null, global);
goog.exportSymbol('proto.accountsettings.SetIndexPageFilterVisibilityRequest', null, global);
goog.exportSymbol('proto.accountsettings.UpdateAccountPromptOverrideSourceRequest', null, global);
goog.exportSymbol('proto.accountsettings.UpdateAccountPromptOverrideSourceResponse', null, global);
goog.exportSymbol('proto.accountsettings.UpdateDateLimitRequest', null, global);
goog.exportSymbol('proto.accountsettings.UpdateDateLimitRequest.SettingCase', null, global);
goog.exportSymbol('proto.accountsettings.UpdateNotificationsPausedRequest', null, global);
goog.exportSymbol('proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest', null, global);
goog.exportSymbol('proto.accountsettings.UpdateValidateImageTimestampsRequest', null, global);
goog.exportSymbol('proto.accountsettings.ValidateImageTimestamps', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.GetChildReportingConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountsettings.GetChildReportingConfigResponse.repeatedFields_, null);
};
goog.inherits(proto.accountsettings.GetChildReportingConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.GetChildReportingConfigResponse.displayName = 'proto.accountsettings.GetChildReportingConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.SaveChildReportingConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountsettings.SaveChildReportingConfigRequest.repeatedFields_, null);
};
goog.inherits(proto.accountsettings.SaveChildReportingConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.SaveChildReportingConfigRequest.displayName = 'proto.accountsettings.SaveChildReportingConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.SaveChildReportingConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountsettings.SaveChildReportingConfigResponse.repeatedFields_, null);
};
goog.inherits(proto.accountsettings.SaveChildReportingConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.SaveChildReportingConfigResponse.displayName = 'proto.accountsettings.SaveChildReportingConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.ValidateImageTimestamps = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.ValidateImageTimestamps, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.ValidateImageTimestamps.displayName = 'proto.accountsettings.ValidateImageTimestamps';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.UpdateValidateImageTimestampsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.UpdateValidateImageTimestampsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.UpdateValidateImageTimestampsRequest.displayName = 'proto.accountsettings.UpdateValidateImageTimestampsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.EarliestEvidencePolicy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.EarliestEvidencePolicy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.EarliestEvidencePolicy.displayName = 'proto.accountsettings.EarliestEvidencePolicy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.GetDateLimitResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.GetDateLimitResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.GetDateLimitResponse.displayName = 'proto.accountsettings.GetDateLimitResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.UpdateDateLimitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.accountsettings.UpdateDateLimitRequest.oneofGroups_);
};
goog.inherits(proto.accountsettings.UpdateDateLimitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.UpdateDateLimitRequest.displayName = 'proto.accountsettings.UpdateDateLimitRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.GetAccountPromptOverrideSourceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.GetAccountPromptOverrideSourceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.GetAccountPromptOverrideSourceResponse.displayName = 'proto.accountsettings.GetAccountPromptOverrideSourceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.UpdateAccountPromptOverrideSourceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.UpdateAccountPromptOverrideSourceRequest.displayName = 'proto.accountsettings.UpdateAccountPromptOverrideSourceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.UpdateAccountPromptOverrideSourceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.UpdateAccountPromptOverrideSourceResponse.displayName = 'proto.accountsettings.UpdateAccountPromptOverrideSourceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.GetUsesNewAuditScanByDefaultResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.GetUsesNewAuditScanByDefaultResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.GetUsesNewAuditScanByDefaultResponse.displayName = 'proto.accountsettings.GetUsesNewAuditScanByDefaultResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest.displayName = 'proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.GetShowOldComplianceDashboardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.GetShowOldComplianceDashboardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.GetShowOldComplianceDashboardResponse.displayName = 'proto.accountsettings.GetShowOldComplianceDashboardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.UpdateNotificationsPausedRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.UpdateNotificationsPausedRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.UpdateNotificationsPausedRequest.displayName = 'proto.accountsettings.UpdateNotificationsPausedRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.IndexPageFilterSettingItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.IndexPageFilterSettingItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.IndexPageFilterSettingItem.displayName = 'proto.accountsettings.IndexPageFilterSettingItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.GetIndexPageFilterSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountsettings.GetIndexPageFilterSettingsResponse.repeatedFields_, null);
};
goog.inherits(proto.accountsettings.GetIndexPageFilterSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.GetIndexPageFilterSettingsResponse.displayName = 'proto.accountsettings.GetIndexPageFilterSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.SetIndexPageFilterVisibilityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.SetIndexPageFilterVisibilityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.SetIndexPageFilterVisibilityRequest.displayName = 'proto.accountsettings.SetIndexPageFilterVisibilityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.ResetIndexPageFiltersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.ResetIndexPageFiltersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.ResetIndexPageFiltersRequest.displayName = 'proto.accountsettings.ResetIndexPageFiltersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.IndexPageColumnSettingItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.IndexPageColumnSettingItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.IndexPageColumnSettingItem.displayName = 'proto.accountsettings.IndexPageColumnSettingItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.GetIndexPageColumnSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountsettings.GetIndexPageColumnSettingsResponse.repeatedFields_, null);
};
goog.inherits(proto.accountsettings.GetIndexPageColumnSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.GetIndexPageColumnSettingsResponse.displayName = 'proto.accountsettings.GetIndexPageColumnSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.SetIndexPageColumnVisibilityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.SetIndexPageColumnVisibilityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.SetIndexPageColumnVisibilityRequest.displayName = 'proto.accountsettings.SetIndexPageColumnVisibilityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.ResetIndexPageColumnsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountsettings.ResetIndexPageColumnsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.ResetIndexPageColumnsRequest.displayName = 'proto.accountsettings.ResetIndexPageColumnsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountsettings.GetHiddenReceptorsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountsettings.GetHiddenReceptorsResponse.repeatedFields_, null);
};
goog.inherits(proto.accountsettings.GetHiddenReceptorsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountsettings.GetHiddenReceptorsResponse.displayName = 'proto.accountsettings.GetHiddenReceptorsResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountsettings.GetChildReportingConfigResponse.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.GetChildReportingConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.GetChildReportingConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetChildReportingConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    hasParent: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    parentAccountName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    parentRegion: jspb.Message.getFieldWithDefault(msg, 3, ""),
    parentIsSameRegion: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    consented: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    termsSuperseded: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    decidedAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
    decidedByEmail: jspb.Message.getFieldWithDefault(msg, 7, ""),
    mode: jspb.Message.getFieldWithDefault(msg, 8, 0),
    selectedControlIdsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.GetChildReportingConfigResponse}
 */
proto.accountsettings.GetChildReportingConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.GetChildReportingConfigResponse;
  return proto.accountsettings.GetChildReportingConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.GetChildReportingConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.GetChildReportingConfigResponse}
 */
proto.accountsettings.GetChildReportingConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasParent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentAccountName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentRegion(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setParentIsSameRegion(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConsented(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTermsSuperseded(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDecidedAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDecidedByEmail(value);
      break;
    case 8:
      var value = /** @type {!proto.accountsettings.CHILD_REPORTING_MODE} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addSelectedControlIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.GetChildReportingConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.GetChildReportingConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetChildReportingConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasParent();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getParentAccountName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParentRegion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getParentIsSameRegion();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getConsented();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getTermsSuperseded();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getDecidedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getDecidedByEmail();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getSelectedControlIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
};


/**
 * optional bool has_parent = 1;
 * @return {boolean}
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.getHasParent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.GetChildReportingConfigResponse} returns this
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.setHasParent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string parent_account_name = 2;
 * @return {string}
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.getParentAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.GetChildReportingConfigResponse} returns this
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.setParentAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string parent_region = 3;
 * @return {string}
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.getParentRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.GetChildReportingConfigResponse} returns this
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.setParentRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool parent_is_same_region = 4;
 * @return {boolean}
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.getParentIsSameRegion = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.GetChildReportingConfigResponse} returns this
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.setParentIsSameRegion = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool consented = 5;
 * @return {boolean}
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.getConsented = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.GetChildReportingConfigResponse} returns this
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.setConsented = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool terms_superseded = 10;
 * @return {boolean}
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.getTermsSuperseded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.GetChildReportingConfigResponse} returns this
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.setTermsSuperseded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional int64 decided_at = 6;
 * @return {number}
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.getDecidedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountsettings.GetChildReportingConfigResponse} returns this
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.setDecidedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string decided_by_email = 7;
 * @return {string}
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.getDecidedByEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.GetChildReportingConfigResponse} returns this
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.setDecidedByEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional CHILD_REPORTING_MODE mode = 8;
 * @return {!proto.accountsettings.CHILD_REPORTING_MODE}
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.getMode = function() {
  return /** @type {!proto.accountsettings.CHILD_REPORTING_MODE} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.accountsettings.CHILD_REPORTING_MODE} value
 * @return {!proto.accountsettings.GetChildReportingConfigResponse} returns this
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * repeated string selected_control_ids = 9;
 * @return {!Array<string>}
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.getSelectedControlIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountsettings.GetChildReportingConfigResponse} returns this
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.setSelectedControlIdsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountsettings.GetChildReportingConfigResponse} returns this
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.addSelectedControlIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountsettings.GetChildReportingConfigResponse} returns this
 */
proto.accountsettings.GetChildReportingConfigResponse.prototype.clearSelectedControlIdsList = function() {
  return this.setSelectedControlIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountsettings.SaveChildReportingConfigRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.SaveChildReportingConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.SaveChildReportingConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.SaveChildReportingConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.SaveChildReportingConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accepted: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    mode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    selectedControlIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.SaveChildReportingConfigRequest}
 */
proto.accountsettings.SaveChildReportingConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.SaveChildReportingConfigRequest;
  return proto.accountsettings.SaveChildReportingConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.SaveChildReportingConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.SaveChildReportingConfigRequest}
 */
proto.accountsettings.SaveChildReportingConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccepted(value);
      break;
    case 2:
      var value = /** @type {!proto.accountsettings.CHILD_REPORTING_MODE} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addSelectedControlIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.SaveChildReportingConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.SaveChildReportingConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.SaveChildReportingConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.SaveChildReportingConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccepted();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSelectedControlIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional bool accepted = 1;
 * @return {boolean}
 */
proto.accountsettings.SaveChildReportingConfigRequest.prototype.getAccepted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.SaveChildReportingConfigRequest} returns this
 */
proto.accountsettings.SaveChildReportingConfigRequest.prototype.setAccepted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional CHILD_REPORTING_MODE mode = 2;
 * @return {!proto.accountsettings.CHILD_REPORTING_MODE}
 */
proto.accountsettings.SaveChildReportingConfigRequest.prototype.getMode = function() {
  return /** @type {!proto.accountsettings.CHILD_REPORTING_MODE} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.accountsettings.CHILD_REPORTING_MODE} value
 * @return {!proto.accountsettings.SaveChildReportingConfigRequest} returns this
 */
proto.accountsettings.SaveChildReportingConfigRequest.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated string selected_control_ids = 3;
 * @return {!Array<string>}
 */
proto.accountsettings.SaveChildReportingConfigRequest.prototype.getSelectedControlIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountsettings.SaveChildReportingConfigRequest} returns this
 */
proto.accountsettings.SaveChildReportingConfigRequest.prototype.setSelectedControlIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountsettings.SaveChildReportingConfigRequest} returns this
 */
proto.accountsettings.SaveChildReportingConfigRequest.prototype.addSelectedControlIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountsettings.SaveChildReportingConfigRequest} returns this
 */
proto.accountsettings.SaveChildReportingConfigRequest.prototype.clearSelectedControlIdsList = function() {
  return this.setSelectedControlIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountsettings.SaveChildReportingConfigResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.SaveChildReportingConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.SaveChildReportingConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.SaveChildReportingConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.SaveChildReportingConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    unreportedControlIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.SaveChildReportingConfigResponse}
 */
proto.accountsettings.SaveChildReportingConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.SaveChildReportingConfigResponse;
  return proto.accountsettings.SaveChildReportingConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.SaveChildReportingConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.SaveChildReportingConfigResponse}
 */
proto.accountsettings.SaveChildReportingConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUnreportedControlIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.SaveChildReportingConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.SaveChildReportingConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.SaveChildReportingConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.SaveChildReportingConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnreportedControlIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string unreported_control_ids = 1;
 * @return {!Array<string>}
 */
proto.accountsettings.SaveChildReportingConfigResponse.prototype.getUnreportedControlIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountsettings.SaveChildReportingConfigResponse} returns this
 */
proto.accountsettings.SaveChildReportingConfigResponse.prototype.setUnreportedControlIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountsettings.SaveChildReportingConfigResponse} returns this
 */
proto.accountsettings.SaveChildReportingConfigResponse.prototype.addUnreportedControlIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountsettings.SaveChildReportingConfigResponse} returns this
 */
proto.accountsettings.SaveChildReportingConfigResponse.prototype.clearUnreportedControlIdsList = function() {
  return this.setUnreportedControlIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.ValidateImageTimestamps.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.ValidateImageTimestamps.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.ValidateImageTimestamps} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.ValidateImageTimestamps.toObject = function(includeInstance, msg) {
  var f, obj = {
    validateImageTimestamps: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.ValidateImageTimestamps}
 */
proto.accountsettings.ValidateImageTimestamps.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.ValidateImageTimestamps;
  return proto.accountsettings.ValidateImageTimestamps.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.ValidateImageTimestamps} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.ValidateImageTimestamps}
 */
proto.accountsettings.ValidateImageTimestamps.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValidateImageTimestamps(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.ValidateImageTimestamps.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.ValidateImageTimestamps.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.ValidateImageTimestamps} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.ValidateImageTimestamps.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValidateImageTimestamps();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool validate_image_timestamps = 1;
 * @return {boolean}
 */
proto.accountsettings.ValidateImageTimestamps.prototype.getValidateImageTimestamps = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.ValidateImageTimestamps} returns this
 */
proto.accountsettings.ValidateImageTimestamps.prototype.setValidateImageTimestamps = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.UpdateValidateImageTimestampsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.UpdateValidateImageTimestampsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.UpdateValidateImageTimestampsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.UpdateValidateImageTimestampsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    validateImageTimestamps: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.UpdateValidateImageTimestampsRequest}
 */
proto.accountsettings.UpdateValidateImageTimestampsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.UpdateValidateImageTimestampsRequest;
  return proto.accountsettings.UpdateValidateImageTimestampsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.UpdateValidateImageTimestampsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.UpdateValidateImageTimestampsRequest}
 */
proto.accountsettings.UpdateValidateImageTimestampsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValidateImageTimestamps(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.UpdateValidateImageTimestampsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.UpdateValidateImageTimestampsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.UpdateValidateImageTimestampsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.UpdateValidateImageTimestampsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValidateImageTimestamps();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool validate_image_timestamps = 1;
 * @return {boolean}
 */
proto.accountsettings.UpdateValidateImageTimestampsRequest.prototype.getValidateImageTimestamps = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.UpdateValidateImageTimestampsRequest} returns this
 */
proto.accountsettings.UpdateValidateImageTimestampsRequest.prototype.setValidateImageTimestamps = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.EarliestEvidencePolicy.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.EarliestEvidencePolicy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.EarliestEvidencePolicy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.EarliestEvidencePolicy.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    slidingMonths: jspb.Message.getFieldWithDefault(msg, 2, 0),
    fixedDate: (f = msg.getFixedDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.EarliestEvidencePolicy}
 */
proto.accountsettings.EarliestEvidencePolicy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.EarliestEvidencePolicy;
  return proto.accountsettings.EarliestEvidencePolicy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.EarliestEvidencePolicy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.EarliestEvidencePolicy}
 */
proto.accountsettings.EarliestEvidencePolicy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.accountsettings.EARLIEST_EVIDENCE_MODE} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSlidingMonths(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFixedDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.EarliestEvidencePolicy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.EarliestEvidencePolicy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.EarliestEvidencePolicy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.EarliestEvidencePolicy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSlidingMonths();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFixedDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional EARLIEST_EVIDENCE_MODE mode = 1;
 * @return {!proto.accountsettings.EARLIEST_EVIDENCE_MODE}
 */
proto.accountsettings.EarliestEvidencePolicy.prototype.getMode = function() {
  return /** @type {!proto.accountsettings.EARLIEST_EVIDENCE_MODE} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.accountsettings.EARLIEST_EVIDENCE_MODE} value
 * @return {!proto.accountsettings.EarliestEvidencePolicy} returns this
 */
proto.accountsettings.EarliestEvidencePolicy.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 sliding_months = 2;
 * @return {number}
 */
proto.accountsettings.EarliestEvidencePolicy.prototype.getSlidingMonths = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountsettings.EarliestEvidencePolicy} returns this
 */
proto.accountsettings.EarliestEvidencePolicy.prototype.setSlidingMonths = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp fixed_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountsettings.EarliestEvidencePolicy.prototype.getFixedDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountsettings.EarliestEvidencePolicy} returns this
*/
proto.accountsettings.EarliestEvidencePolicy.prototype.setFixedDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountsettings.EarliestEvidencePolicy} returns this
 */
proto.accountsettings.EarliestEvidencePolicy.prototype.clearFixedDate = function() {
  return this.setFixedDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountsettings.EarliestEvidencePolicy.prototype.hasFixedDate = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.GetDateLimitResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.GetDateLimitResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.GetDateLimitResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetDateLimitResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    dateLimit: (f = msg.getDateLimit()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    policy: (f = msg.getPolicy()) && proto.accountsettings.EarliestEvidencePolicy.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.GetDateLimitResponse}
 */
proto.accountsettings.GetDateLimitResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.GetDateLimitResponse;
  return proto.accountsettings.GetDateLimitResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.GetDateLimitResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.GetDateLimitResponse}
 */
proto.accountsettings.GetDateLimitResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateLimit(value);
      break;
    case 2:
      var value = new proto.accountsettings.EarliestEvidencePolicy;
      reader.readMessage(value,proto.accountsettings.EarliestEvidencePolicy.deserializeBinaryFromReader);
      msg.setPolicy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.GetDateLimitResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.GetDateLimitResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.GetDateLimitResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetDateLimitResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDateLimit();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPolicy();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.accountsettings.EarliestEvidencePolicy.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp date_limit = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountsettings.GetDateLimitResponse.prototype.getDateLimit = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountsettings.GetDateLimitResponse} returns this
*/
proto.accountsettings.GetDateLimitResponse.prototype.setDateLimit = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountsettings.GetDateLimitResponse} returns this
 */
proto.accountsettings.GetDateLimitResponse.prototype.clearDateLimit = function() {
  return this.setDateLimit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountsettings.GetDateLimitResponse.prototype.hasDateLimit = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EarliestEvidencePolicy policy = 2;
 * @return {?proto.accountsettings.EarliestEvidencePolicy}
 */
proto.accountsettings.GetDateLimitResponse.prototype.getPolicy = function() {
  return /** @type{?proto.accountsettings.EarliestEvidencePolicy} */ (
    jspb.Message.getWrapperField(this, proto.accountsettings.EarliestEvidencePolicy, 2));
};


/**
 * @param {?proto.accountsettings.EarliestEvidencePolicy|undefined} value
 * @return {!proto.accountsettings.GetDateLimitResponse} returns this
*/
proto.accountsettings.GetDateLimitResponse.prototype.setPolicy = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountsettings.GetDateLimitResponse} returns this
 */
proto.accountsettings.GetDateLimitResponse.prototype.clearPolicy = function() {
  return this.setPolicy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountsettings.GetDateLimitResponse.prototype.hasPolicy = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.accountsettings.UpdateDateLimitRequest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.accountsettings.UpdateDateLimitRequest.SettingCase = {
  SETTING_NOT_SET: 0,
  FIXED_DATE: 2,
  SLIDING_MONTHS: 3
};

/**
 * @return {proto.accountsettings.UpdateDateLimitRequest.SettingCase}
 */
proto.accountsettings.UpdateDateLimitRequest.prototype.getSettingCase = function() {
  return /** @type {proto.accountsettings.UpdateDateLimitRequest.SettingCase} */(jspb.Message.computeOneofCase(this, proto.accountsettings.UpdateDateLimitRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.UpdateDateLimitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.UpdateDateLimitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.UpdateDateLimitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.UpdateDateLimitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dateLimit: (f = msg.getDateLimit()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    fixedDate: (f = msg.getFixedDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    slidingMonths: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.UpdateDateLimitRequest}
 */
proto.accountsettings.UpdateDateLimitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.UpdateDateLimitRequest;
  return proto.accountsettings.UpdateDateLimitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.UpdateDateLimitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.UpdateDateLimitRequest}
 */
proto.accountsettings.UpdateDateLimitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateLimit(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFixedDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSlidingMonths(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.UpdateDateLimitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.UpdateDateLimitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.UpdateDateLimitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.UpdateDateLimitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDateLimit();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFixedDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp date_limit = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountsettings.UpdateDateLimitRequest.prototype.getDateLimit = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountsettings.UpdateDateLimitRequest} returns this
*/
proto.accountsettings.UpdateDateLimitRequest.prototype.setDateLimit = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountsettings.UpdateDateLimitRequest} returns this
 */
proto.accountsettings.UpdateDateLimitRequest.prototype.clearDateLimit = function() {
  return this.setDateLimit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountsettings.UpdateDateLimitRequest.prototype.hasDateLimit = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp fixed_date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountsettings.UpdateDateLimitRequest.prototype.getFixedDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountsettings.UpdateDateLimitRequest} returns this
*/
proto.accountsettings.UpdateDateLimitRequest.prototype.setFixedDate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.accountsettings.UpdateDateLimitRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountsettings.UpdateDateLimitRequest} returns this
 */
proto.accountsettings.UpdateDateLimitRequest.prototype.clearFixedDate = function() {
  return this.setFixedDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountsettings.UpdateDateLimitRequest.prototype.hasFixedDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 sliding_months = 3;
 * @return {number}
 */
proto.accountsettings.UpdateDateLimitRequest.prototype.getSlidingMonths = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountsettings.UpdateDateLimitRequest} returns this
 */
proto.accountsettings.UpdateDateLimitRequest.prototype.setSlidingMonths = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.accountsettings.UpdateDateLimitRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accountsettings.UpdateDateLimitRequest} returns this
 */
proto.accountsettings.UpdateDateLimitRequest.prototype.clearSlidingMonths = function() {
  return jspb.Message.setOneofField(this, 3, proto.accountsettings.UpdateDateLimitRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountsettings.UpdateDateLimitRequest.prototype.hasSlidingMonths = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.GetAccountPromptOverrideSourceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.GetAccountPromptOverrideSourceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.GetAccountPromptOverrideSourceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetAccountPromptOverrideSourceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    source: (f = msg.getSource()) && promptoverridesources_promptoverridesources_pb.PromptOverrideSource.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.GetAccountPromptOverrideSourceResponse}
 */
proto.accountsettings.GetAccountPromptOverrideSourceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.GetAccountPromptOverrideSourceResponse;
  return proto.accountsettings.GetAccountPromptOverrideSourceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.GetAccountPromptOverrideSourceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.GetAccountPromptOverrideSourceResponse}
 */
proto.accountsettings.GetAccountPromptOverrideSourceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new promptoverridesources_promptoverridesources_pb.PromptOverrideSource;
      reader.readMessage(value,promptoverridesources_promptoverridesources_pb.PromptOverrideSource.deserializeBinaryFromReader);
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.GetAccountPromptOverrideSourceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.GetAccountPromptOverrideSourceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.GetAccountPromptOverrideSourceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetAccountPromptOverrideSourceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      promptoverridesources_promptoverridesources_pb.PromptOverrideSource.serializeBinaryToWriter
    );
  }
};


/**
 * optional promptoverridesources.PromptOverrideSource source = 1;
 * @return {?proto.promptoverridesources.PromptOverrideSource}
 */
proto.accountsettings.GetAccountPromptOverrideSourceResponse.prototype.getSource = function() {
  return /** @type{?proto.promptoverridesources.PromptOverrideSource} */ (
    jspb.Message.getWrapperField(this, promptoverridesources_promptoverridesources_pb.PromptOverrideSource, 1));
};


/**
 * @param {?proto.promptoverridesources.PromptOverrideSource|undefined} value
 * @return {!proto.accountsettings.GetAccountPromptOverrideSourceResponse} returns this
*/
proto.accountsettings.GetAccountPromptOverrideSourceResponse.prototype.setSource = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountsettings.GetAccountPromptOverrideSourceResponse} returns this
 */
proto.accountsettings.GetAccountPromptOverrideSourceResponse.prototype.clearSource = function() {
  return this.setSource(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountsettings.GetAccountPromptOverrideSourceResponse.prototype.hasSource = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.UpdateAccountPromptOverrideSourceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.UpdateAccountPromptOverrideSourceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.UpdateAccountPromptOverrideSourceRequest}
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.UpdateAccountPromptOverrideSourceRequest;
  return proto.accountsettings.UpdateAccountPromptOverrideSourceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.UpdateAccountPromptOverrideSourceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.UpdateAccountPromptOverrideSourceRequest}
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.UpdateAccountPromptOverrideSourceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.UpdateAccountPromptOverrideSourceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.UpdateAccountPromptOverrideSourceRequest} returns this
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.UpdateAccountPromptOverrideSourceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.UpdateAccountPromptOverrideSourceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.UpdateAccountPromptOverrideSourceResponse}
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.UpdateAccountPromptOverrideSourceResponse;
  return proto.accountsettings.UpdateAccountPromptOverrideSourceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.UpdateAccountPromptOverrideSourceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.UpdateAccountPromptOverrideSourceResponse}
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.UpdateAccountPromptOverrideSourceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.UpdateAccountPromptOverrideSourceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.UpdateAccountPromptOverrideSourceResponse} returns this
 */
proto.accountsettings.UpdateAccountPromptOverrideSourceResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.GetUsesNewAuditScanByDefaultResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.GetUsesNewAuditScanByDefaultResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.GetUsesNewAuditScanByDefaultResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetUsesNewAuditScanByDefaultResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    usesNewAuditScanByDefault: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.GetUsesNewAuditScanByDefaultResponse}
 */
proto.accountsettings.GetUsesNewAuditScanByDefaultResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.GetUsesNewAuditScanByDefaultResponse;
  return proto.accountsettings.GetUsesNewAuditScanByDefaultResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.GetUsesNewAuditScanByDefaultResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.GetUsesNewAuditScanByDefaultResponse}
 */
proto.accountsettings.GetUsesNewAuditScanByDefaultResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUsesNewAuditScanByDefault(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.GetUsesNewAuditScanByDefaultResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.GetUsesNewAuditScanByDefaultResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.GetUsesNewAuditScanByDefaultResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetUsesNewAuditScanByDefaultResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsesNewAuditScanByDefault();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool uses_new_audit_scan_by_default = 1;
 * @return {boolean}
 */
proto.accountsettings.GetUsesNewAuditScanByDefaultResponse.prototype.getUsesNewAuditScanByDefault = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.GetUsesNewAuditScanByDefaultResponse} returns this
 */
proto.accountsettings.GetUsesNewAuditScanByDefaultResponse.prototype.setUsesNewAuditScanByDefault = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    usesNewAuditScanByDefault: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest}
 */
proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest;
  return proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest}
 */
proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUsesNewAuditScanByDefault(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsesNewAuditScanByDefault();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool uses_new_audit_scan_by_default = 1;
 * @return {boolean}
 */
proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest.prototype.getUsesNewAuditScanByDefault = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest} returns this
 */
proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest.prototype.setUsesNewAuditScanByDefault = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.GetShowOldComplianceDashboardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.GetShowOldComplianceDashboardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.GetShowOldComplianceDashboardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetShowOldComplianceDashboardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    showOldComplianceDashboard: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.GetShowOldComplianceDashboardResponse}
 */
proto.accountsettings.GetShowOldComplianceDashboardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.GetShowOldComplianceDashboardResponse;
  return proto.accountsettings.GetShowOldComplianceDashboardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.GetShowOldComplianceDashboardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.GetShowOldComplianceDashboardResponse}
 */
proto.accountsettings.GetShowOldComplianceDashboardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowOldComplianceDashboard(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.GetShowOldComplianceDashboardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.GetShowOldComplianceDashboardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.GetShowOldComplianceDashboardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetShowOldComplianceDashboardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShowOldComplianceDashboard();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool show_old_compliance_dashboard = 1;
 * @return {boolean}
 */
proto.accountsettings.GetShowOldComplianceDashboardResponse.prototype.getShowOldComplianceDashboard = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.GetShowOldComplianceDashboardResponse} returns this
 */
proto.accountsettings.GetShowOldComplianceDashboardResponse.prototype.setShowOldComplianceDashboard = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.UpdateNotificationsPausedRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.UpdateNotificationsPausedRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.UpdateNotificationsPausedRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.UpdateNotificationsPausedRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    paused: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    reason: jspb.Message.getFieldWithDefault(msg, 2, ""),
    durationValue: jspb.Message.getFieldWithDefault(msg, 3, 0),
    durationUnit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.UpdateNotificationsPausedRequest}
 */
proto.accountsettings.UpdateNotificationsPausedRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.UpdateNotificationsPausedRequest;
  return proto.accountsettings.UpdateNotificationsPausedRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.UpdateNotificationsPausedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.UpdateNotificationsPausedRequest}
 */
proto.accountsettings.UpdateNotificationsPausedRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaused(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDurationValue(value);
      break;
    case 4:
      var value = /** @type {!proto.accountsettings.PAUSE_DURATION_UNIT} */ (reader.readEnum());
      msg.setDurationUnit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.UpdateNotificationsPausedRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.UpdateNotificationsPausedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.UpdateNotificationsPausedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.UpdateNotificationsPausedRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaused();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDurationValue();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDurationUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional bool paused = 1;
 * @return {boolean}
 */
proto.accountsettings.UpdateNotificationsPausedRequest.prototype.getPaused = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.UpdateNotificationsPausedRequest} returns this
 */
proto.accountsettings.UpdateNotificationsPausedRequest.prototype.setPaused = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.accountsettings.UpdateNotificationsPausedRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.UpdateNotificationsPausedRequest} returns this
 */
proto.accountsettings.UpdateNotificationsPausedRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 duration_value = 3;
 * @return {number}
 */
proto.accountsettings.UpdateNotificationsPausedRequest.prototype.getDurationValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountsettings.UpdateNotificationsPausedRequest} returns this
 */
proto.accountsettings.UpdateNotificationsPausedRequest.prototype.setDurationValue = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional PAUSE_DURATION_UNIT duration_unit = 4;
 * @return {!proto.accountsettings.PAUSE_DURATION_UNIT}
 */
proto.accountsettings.UpdateNotificationsPausedRequest.prototype.getDurationUnit = function() {
  return /** @type {!proto.accountsettings.PAUSE_DURATION_UNIT} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.accountsettings.PAUSE_DURATION_UNIT} value
 * @return {!proto.accountsettings.UpdateNotificationsPausedRequest} returns this
 */
proto.accountsettings.UpdateNotificationsPausedRequest.prototype.setDurationUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.IndexPageFilterSettingItem.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.IndexPageFilterSettingItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.IndexPageFilterSettingItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.IndexPageFilterSettingItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filterKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    hidden: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.IndexPageFilterSettingItem}
 */
proto.accountsettings.IndexPageFilterSettingItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.IndexPageFilterSettingItem;
  return proto.accountsettings.IndexPageFilterSettingItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.IndexPageFilterSettingItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.IndexPageFilterSettingItem}
 */
proto.accountsettings.IndexPageFilterSettingItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilterKey(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHidden(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.IndexPageFilterSettingItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.IndexPageFilterSettingItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.IndexPageFilterSettingItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.IndexPageFilterSettingItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilterKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHidden();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string page = 1;
 * @return {string}
 */
proto.accountsettings.IndexPageFilterSettingItem.prototype.getPage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.IndexPageFilterSettingItem} returns this
 */
proto.accountsettings.IndexPageFilterSettingItem.prototype.setPage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filter_key = 2;
 * @return {string}
 */
proto.accountsettings.IndexPageFilterSettingItem.prototype.getFilterKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.IndexPageFilterSettingItem} returns this
 */
proto.accountsettings.IndexPageFilterSettingItem.prototype.setFilterKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool hidden = 3;
 * @return {boolean}
 */
proto.accountsettings.IndexPageFilterSettingItem.prototype.getHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.IndexPageFilterSettingItem} returns this
 */
proto.accountsettings.IndexPageFilterSettingItem.prototype.setHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountsettings.GetIndexPageFilterSettingsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.GetIndexPageFilterSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.GetIndexPageFilterSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.GetIndexPageFilterSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetIndexPageFilterSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.accountsettings.IndexPageFilterSettingItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.GetIndexPageFilterSettingsResponse}
 */
proto.accountsettings.GetIndexPageFilterSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.GetIndexPageFilterSettingsResponse;
  return proto.accountsettings.GetIndexPageFilterSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.GetIndexPageFilterSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.GetIndexPageFilterSettingsResponse}
 */
proto.accountsettings.GetIndexPageFilterSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountsettings.IndexPageFilterSettingItem;
      reader.readMessage(value,proto.accountsettings.IndexPageFilterSettingItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.GetIndexPageFilterSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.GetIndexPageFilterSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.GetIndexPageFilterSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetIndexPageFilterSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountsettings.IndexPageFilterSettingItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated IndexPageFilterSettingItem items = 1;
 * @return {!Array<!proto.accountsettings.IndexPageFilterSettingItem>}
 */
proto.accountsettings.GetIndexPageFilterSettingsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.accountsettings.IndexPageFilterSettingItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountsettings.IndexPageFilterSettingItem, 1));
};


/**
 * @param {!Array<!proto.accountsettings.IndexPageFilterSettingItem>} value
 * @return {!proto.accountsettings.GetIndexPageFilterSettingsResponse} returns this
*/
proto.accountsettings.GetIndexPageFilterSettingsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountsettings.IndexPageFilterSettingItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountsettings.IndexPageFilterSettingItem}
 */
proto.accountsettings.GetIndexPageFilterSettingsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountsettings.IndexPageFilterSettingItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountsettings.GetIndexPageFilterSettingsResponse} returns this
 */
proto.accountsettings.GetIndexPageFilterSettingsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.SetIndexPageFilterVisibilityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.SetIndexPageFilterVisibilityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.SetIndexPageFilterVisibilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.SetIndexPageFilterVisibilityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filterKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    hidden: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.SetIndexPageFilterVisibilityRequest}
 */
proto.accountsettings.SetIndexPageFilterVisibilityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.SetIndexPageFilterVisibilityRequest;
  return proto.accountsettings.SetIndexPageFilterVisibilityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.SetIndexPageFilterVisibilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.SetIndexPageFilterVisibilityRequest}
 */
proto.accountsettings.SetIndexPageFilterVisibilityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilterKey(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHidden(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.SetIndexPageFilterVisibilityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.SetIndexPageFilterVisibilityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.SetIndexPageFilterVisibilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.SetIndexPageFilterVisibilityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilterKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHidden();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string page = 1;
 * @return {string}
 */
proto.accountsettings.SetIndexPageFilterVisibilityRequest.prototype.getPage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.SetIndexPageFilterVisibilityRequest} returns this
 */
proto.accountsettings.SetIndexPageFilterVisibilityRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filter_key = 2;
 * @return {string}
 */
proto.accountsettings.SetIndexPageFilterVisibilityRequest.prototype.getFilterKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.SetIndexPageFilterVisibilityRequest} returns this
 */
proto.accountsettings.SetIndexPageFilterVisibilityRequest.prototype.setFilterKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool hidden = 3;
 * @return {boolean}
 */
proto.accountsettings.SetIndexPageFilterVisibilityRequest.prototype.getHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.SetIndexPageFilterVisibilityRequest} returns this
 */
proto.accountsettings.SetIndexPageFilterVisibilityRequest.prototype.setHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.ResetIndexPageFiltersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.ResetIndexPageFiltersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.ResetIndexPageFiltersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.ResetIndexPageFiltersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.ResetIndexPageFiltersRequest}
 */
proto.accountsettings.ResetIndexPageFiltersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.ResetIndexPageFiltersRequest;
  return proto.accountsettings.ResetIndexPageFiltersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.ResetIndexPageFiltersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.ResetIndexPageFiltersRequest}
 */
proto.accountsettings.ResetIndexPageFiltersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.ResetIndexPageFiltersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.ResetIndexPageFiltersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.ResetIndexPageFiltersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.ResetIndexPageFiltersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string page = 1;
 * @return {string}
 */
proto.accountsettings.ResetIndexPageFiltersRequest.prototype.getPage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.ResetIndexPageFiltersRequest} returns this
 */
proto.accountsettings.ResetIndexPageFiltersRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.IndexPageColumnSettingItem.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.IndexPageColumnSettingItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.IndexPageColumnSettingItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.IndexPageColumnSettingItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: jspb.Message.getFieldWithDefault(msg, 1, ""),
    columnKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    hidden: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.IndexPageColumnSettingItem}
 */
proto.accountsettings.IndexPageColumnSettingItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.IndexPageColumnSettingItem;
  return proto.accountsettings.IndexPageColumnSettingItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.IndexPageColumnSettingItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.IndexPageColumnSettingItem}
 */
proto.accountsettings.IndexPageColumnSettingItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setColumnKey(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHidden(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.IndexPageColumnSettingItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.IndexPageColumnSettingItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.IndexPageColumnSettingItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.IndexPageColumnSettingItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getColumnKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHidden();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string page = 1;
 * @return {string}
 */
proto.accountsettings.IndexPageColumnSettingItem.prototype.getPage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.IndexPageColumnSettingItem} returns this
 */
proto.accountsettings.IndexPageColumnSettingItem.prototype.setPage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string column_key = 2;
 * @return {string}
 */
proto.accountsettings.IndexPageColumnSettingItem.prototype.getColumnKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.IndexPageColumnSettingItem} returns this
 */
proto.accountsettings.IndexPageColumnSettingItem.prototype.setColumnKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool hidden = 3;
 * @return {boolean}
 */
proto.accountsettings.IndexPageColumnSettingItem.prototype.getHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.IndexPageColumnSettingItem} returns this
 */
proto.accountsettings.IndexPageColumnSettingItem.prototype.setHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountsettings.GetIndexPageColumnSettingsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.GetIndexPageColumnSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.GetIndexPageColumnSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.GetIndexPageColumnSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetIndexPageColumnSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.accountsettings.IndexPageColumnSettingItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.GetIndexPageColumnSettingsResponse}
 */
proto.accountsettings.GetIndexPageColumnSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.GetIndexPageColumnSettingsResponse;
  return proto.accountsettings.GetIndexPageColumnSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.GetIndexPageColumnSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.GetIndexPageColumnSettingsResponse}
 */
proto.accountsettings.GetIndexPageColumnSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountsettings.IndexPageColumnSettingItem;
      reader.readMessage(value,proto.accountsettings.IndexPageColumnSettingItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.GetIndexPageColumnSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.GetIndexPageColumnSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.GetIndexPageColumnSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetIndexPageColumnSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountsettings.IndexPageColumnSettingItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated IndexPageColumnSettingItem items = 1;
 * @return {!Array<!proto.accountsettings.IndexPageColumnSettingItem>}
 */
proto.accountsettings.GetIndexPageColumnSettingsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.accountsettings.IndexPageColumnSettingItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountsettings.IndexPageColumnSettingItem, 1));
};


/**
 * @param {!Array<!proto.accountsettings.IndexPageColumnSettingItem>} value
 * @return {!proto.accountsettings.GetIndexPageColumnSettingsResponse} returns this
*/
proto.accountsettings.GetIndexPageColumnSettingsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountsettings.IndexPageColumnSettingItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountsettings.IndexPageColumnSettingItem}
 */
proto.accountsettings.GetIndexPageColumnSettingsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountsettings.IndexPageColumnSettingItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountsettings.GetIndexPageColumnSettingsResponse} returns this
 */
proto.accountsettings.GetIndexPageColumnSettingsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.SetIndexPageColumnVisibilityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.SetIndexPageColumnVisibilityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.SetIndexPageColumnVisibilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.SetIndexPageColumnVisibilityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: jspb.Message.getFieldWithDefault(msg, 1, ""),
    columnKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    hidden: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.SetIndexPageColumnVisibilityRequest}
 */
proto.accountsettings.SetIndexPageColumnVisibilityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.SetIndexPageColumnVisibilityRequest;
  return proto.accountsettings.SetIndexPageColumnVisibilityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.SetIndexPageColumnVisibilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.SetIndexPageColumnVisibilityRequest}
 */
proto.accountsettings.SetIndexPageColumnVisibilityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setColumnKey(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHidden(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.SetIndexPageColumnVisibilityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.SetIndexPageColumnVisibilityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.SetIndexPageColumnVisibilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.SetIndexPageColumnVisibilityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getColumnKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHidden();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string page = 1;
 * @return {string}
 */
proto.accountsettings.SetIndexPageColumnVisibilityRequest.prototype.getPage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.SetIndexPageColumnVisibilityRequest} returns this
 */
proto.accountsettings.SetIndexPageColumnVisibilityRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string column_key = 2;
 * @return {string}
 */
proto.accountsettings.SetIndexPageColumnVisibilityRequest.prototype.getColumnKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.SetIndexPageColumnVisibilityRequest} returns this
 */
proto.accountsettings.SetIndexPageColumnVisibilityRequest.prototype.setColumnKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool hidden = 3;
 * @return {boolean}
 */
proto.accountsettings.SetIndexPageColumnVisibilityRequest.prototype.getHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountsettings.SetIndexPageColumnVisibilityRequest} returns this
 */
proto.accountsettings.SetIndexPageColumnVisibilityRequest.prototype.setHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.ResetIndexPageColumnsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.ResetIndexPageColumnsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.ResetIndexPageColumnsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.ResetIndexPageColumnsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.ResetIndexPageColumnsRequest}
 */
proto.accountsettings.ResetIndexPageColumnsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.ResetIndexPageColumnsRequest;
  return proto.accountsettings.ResetIndexPageColumnsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.ResetIndexPageColumnsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.ResetIndexPageColumnsRequest}
 */
proto.accountsettings.ResetIndexPageColumnsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.ResetIndexPageColumnsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.ResetIndexPageColumnsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.ResetIndexPageColumnsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.ResetIndexPageColumnsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string page = 1;
 * @return {string}
 */
proto.accountsettings.ResetIndexPageColumnsRequest.prototype.getPage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountsettings.ResetIndexPageColumnsRequest} returns this
 */
proto.accountsettings.ResetIndexPageColumnsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountsettings.GetHiddenReceptorsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountsettings.GetHiddenReceptorsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountsettings.GetHiddenReceptorsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountsettings.GetHiddenReceptorsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetHiddenReceptorsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorModelIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountsettings.GetHiddenReceptorsResponse}
 */
proto.accountsettings.GetHiddenReceptorsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountsettings.GetHiddenReceptorsResponse;
  return proto.accountsettings.GetHiddenReceptorsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountsettings.GetHiddenReceptorsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountsettings.GetHiddenReceptorsResponse}
 */
proto.accountsettings.GetHiddenReceptorsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addReceptorModelIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountsettings.GetHiddenReceptorsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountsettings.GetHiddenReceptorsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountsettings.GetHiddenReceptorsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountsettings.GetHiddenReceptorsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorModelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string receptor_model_ids = 1;
 * @return {!Array<string>}
 */
proto.accountsettings.GetHiddenReceptorsResponse.prototype.getReceptorModelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accountsettings.GetHiddenReceptorsResponse} returns this
 */
proto.accountsettings.GetHiddenReceptorsResponse.prototype.setReceptorModelIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accountsettings.GetHiddenReceptorsResponse} returns this
 */
proto.accountsettings.GetHiddenReceptorsResponse.prototype.addReceptorModelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountsettings.GetHiddenReceptorsResponse} returns this
 */
proto.accountsettings.GetHiddenReceptorsResponse.prototype.clearReceptorModelIdsList = function() {
  return this.setReceptorModelIdsList([]);
};


/**
 * @enum {number}
 */
proto.accountsettings.CHILD_REPORTING_MODE = {
  REPORT_ALL_CONTROLS: 0,
  REPORT_SELECTED_CONTROLS: 1
};

/**
 * @enum {number}
 */
proto.accountsettings.EARLIEST_EVIDENCE_MODE = {
  EARLIEST_EVIDENCE_FIXED: 0,
  EARLIEST_EVIDENCE_SLIDING: 1
};

/**
 * @enum {number}
 */
proto.accountsettings.PAUSE_DURATION_UNIT = {
  UNSPECIFIED: 0,
  PAUSE_HOURS: 1,
  PAUSE_DAYS: 2
};

goog.object.extend(exports, proto.accountsettings);
